import Yup from '~/utils/validations/yup';

export const schemaValidation = Yup.object({
  singularLabel: Yup.string().required(),
  pluralLabel: Yup.string().required(),
});
